export default class DrillingRecord {
  constructor() {
    this.deepestDrilled = null;
    this.deepestPushed = null;
    this.latestMethod = null;
    this.latestElevation = null;
  }

  update(newDrillingElevation, method) {
    if (method === 'drill') {
      if (!this.deepestDrilled || newDrillingElevation < this.deepestDrilled) {
        this.deepestDrilled = newDrillingElevation;
      }
    } else if (
      this.deepestPushed == null ||
      newDrillingElevation < this.deepestPushed
    ) {
      this.deepestPushed = newDrillingElevation;
    }
    this.latestMethod = method;
    this.latestElevation = newDrillingElevation;
  }
}
